import { APP_CHAT_PATH } from "src/lib/createAppPath";

export enum LeapChatPath {
  new = "new",
  updates = "updates",
  conversation = "conversation/:id"
}

export const chatConversationPath = (id: string) =>
  `${APP_CHAT_PATH}/conversation/${id}`;

export const CHAT_NEW_PATH = `${APP_CHAT_PATH}/new`;
